module.exports = __webpack_public_path__ + "static/media/orderSales.6f53c64b.ico";